import { render, staticRenderFns } from "./channelMe.vue?vue&type=template&id=3195ed92&scoped=true"
import script from "./channelMe.vue?vue&type=script&lang=js"
export * from "./channelMe.vue?vue&type=script&lang=js"
import style0 from "./channelMe.vue?vue&type=style&index=0&id=3195ed92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3195ed92",
  null
  
)

export default component.exports